import React from 'react';
import { Routes, Route, useNavigate } from "react-router-dom";
import AdminLayout from '../Layout/Adminindex';
import Home from '../Components/Admin/Home';
import List from '../Components/Admin/List';
import ExhibitorEdit from '../Components/Admin/ExhibitorEdit';
import EventList from '../Components/Admin/EventList';
import Editeventdetails from '../Components/Admin/EditEventdetails';
import ProgrammingList from '../Components/Admin/ProgrammingList';
import CreateProgramming from '../Components/Admin/CreateProgramming';
import Galleryreviews from '../Components/Admin/GalleryReviews';
import CreateGalleryreview from '../Components/Admin/CreateGalleryreview';
import Viewapplicants from '../Components/Admin/ViewApplicants';
import AddEventdetails from '../Components/Admin/AddEventdetails';
import EditProgramming from '../Components/Admin/EditProgramming';
import EditGalleryreview from '../Components/Admin/EditGalleryreview';
import ViewApplication from '../Components/Admin/ViewApplicants';
import ViewDeniedApplication from '../Components/Admin/ViewDeniedApplicants';
//import Auth from "../Helper/Auth";
import Logout from '../Components/Logout';
//import Login from '../Components/Login/Login';
import SubscriptionList from '../Components/Admin/SubscriptionList';
import CreateSubscription from '../Components/Admin/CreateSubscription';
import EditSubscription from '../Components/Admin/EditSubscription';
import SubscriberList from '../Components/Admin/SubscriberList';
import AdminApplication from '../Components/Admin/AdminApplication';




export default function AdminRoutes(){
  const navigation = useNavigate();
  //let auth = Auth();
  
  //if(Auth()){ //If user Logged in
    return(
        <Routes >
          <Route element={<AdminLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/home" element={<Home />} />
            <Route path="/list" element={<List />} />
            <Route path="/eventlist" element={<EventList />} />
            <Route path="/editeventdetails/:eventId" element={<Editeventdetails />} />
            <Route path="/exhibitor_edit/:id" element={<ExhibitorEdit />} />
            <Route path="/editeventdetails" element={<Editeventdetails />} />
            <Route path="/Programminglist/:id" element={<ProgrammingList />} />
            <Route path="/createprogramming/:id" element={<CreateProgramming />} />
            <Route path="/galleryreviews" element={<Galleryreviews />} />
            <Route path="/creategalleryreview" element={<CreateGalleryreview />} />
            <Route path="/viewapplicants" element={<Viewapplicants />} />
            <Route path="/addeventdetails" element={<AddEventdetails />} />
            <Route path="/EditProgramming/:pro_id/:eve_id" element={<EditProgramming />} />
            <Route path="/editgalleryreview/:epro_id" element={<EditGalleryreview />} />
            <Route path="/view_application/:id" element={<ViewApplication />} />
            <Route path="/view_denied_application/:id" element={<ViewDeniedApplication />} />
            <Route path="/admin-subscription" element={<SubscriptionList />} />
            <Route path="/add-subscription" element={<CreateSubscription />} />
            <Route path="/edit-subscription/:subscriptionId" element={<EditSubscription />} />
            <Route path="/admin-subscriber" element={<SubscriberList />} />
            <Route path="/adminapplication/:id" element={<AdminApplication />} />

          </Route>
      </Routes>
    )
}